import { render, staticRenderFns } from "./GrabberConfigs.vue?vue&type=template&id=3bd4cc17&scoped=true"
import script from "./GrabberConfigs.vue?vue&type=script&lang=ts"
export * from "./GrabberConfigs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd4cc17",
  null
  
)

export default component.exports